'use client'

import { Box, Container, useBreakpointValue } from '@chakra-ui/react'
import React, { memo, useEffect, useState } from 'react'
import HeaderDesktop from './header.desktop'
import HeaderMobile from './header.mobile'
import ErrorModal from './_components/ErrorModal'
import { useTranslations } from 'next-intl'
import { shallowEqual, useSelector } from 'react-redux'
import { IRedux } from '@/app/[locale]/_store/types'
import { useQuery } from '@tanstack/react-query'
import { branchService } from '@/app/[locale]/_service/branch.service'
import useDelivery from './_hooks/useDelivery'
import Websites from './_components/Websites'

const Header = () => {
  const [orderTypeError, setOrderTypeError] = useState(false)
  // const isDesktop = useBreakpointValue(
  //   { base: false, lg: true },
  //   { ssr: false }
  // )
  const t = useTranslations()

  const { branch, settings, session } = useSelector(
    (state: IRedux) => ({
      branch: state.common?.branch,
      settings: state.settings?.data,
      session: state.session,
    }),
    shallowEqual
  )
  const { is_hall, branch_id, shipper_id, order_type } = session

  useDelivery({ enabled: !settings?.choose_delivery_branch })

  const { data: branchData } = useQuery({
    queryKey: ['branch-by-id', branch?.id, is_hall, branch_id],
    queryFn: () =>
      branchService
        .getBranchById((is_hall === 'true' && branch_id) || branch?.id || '')
        .then((res) => res.data),
    enabled:
      Boolean(
        (order_type?.type == 'self-pickup' || order_type?.type == 'hall') &&
        branch?.id
      ) || Boolean(is_hall === 'true' && branch_id && shipper_id),
  })

  useEffect(() => {
    if (
      order_type?.id === '6d9f3d3b-c385-4fed-8273-8f213b82ffef' &&
      !branchData?.order_type_ids?.includes(order_type?.id) &&
      branchData &&
      branch?.id
    ) {
      setOrderTypeError(true)
    }
  }, [order_type?.id])

  // return isDesktop ? (
  //   <>
  //     <Box bg='primary'>
  //       {settings?.data?.websites && settings?.data?.websites?.length > 0 && (
  //         <Container display='flex' alignItems='end' px={10} pt='7px'>
  //           <Websites websites={settings?.data?.websites} />
  //         </Container>
  //       )}
  //     </Box>
  //     <ErrorModal
  //       isOpen={Boolean(orderTypeError)}
  //       title={t('attention')}
  //       description={t('checkout.branch_unavailable_pickup')}
  //       confirmText={t('checkout.change_branch')}
  //       onClose={() => setOrderTypeError(false)}
  //     />
  //     <Box
  //       display={{ base: 'none', lg: 'block' }}
  //       position='sticky'
  //       top={0}
  //       bg='background.card'
  //       zIndex={30}
  //     >
  //       <HeaderDesktop />
  //     </Box>
  //   </>
  // ) :

  return (
    <>
      <Box
        display={{ base: 'block', lg: 'none' }}
        position='sticky'
        pt='var(--tg-safe-area-inset-top)'
        pb={4}
        top={0}
        bg='background.card'
        color='text'
        zIndex={30}
      >
        <HeaderMobile />
      </Box>
      <ErrorModal
        isOpen={Boolean(orderTypeError)}
        title={t('attention')}
        description={t('checkout.branch_unavailable_pickup')}
        confirmText={t('checkout.change_branch')}
        onClose={() => setOrderTypeError(false)}
      />
      {settings?.data?.websites && settings?.data?.websites?.length > 0 && (
        <Websites websites={settings?.data?.websites} />
      )}
    </>
  )
}

export default memo(Header)
